<template>
  <div id="checkout-page">
    <Checkout api="cityaventure-lyon-albigny"/>
  </div>
</template>

<script>
  export default {

  }
</script>

<style>

</style>
